import React, { useEffect } from 'react';
import { Check, AlertTriangle, Info, X } from 'lucide-react';
interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}
export function Toast({
  message,
  type = 'success',
  isVisible,
  onClose,
  duration = 3000
}: ToastProps) {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);
  if (!isVisible) return null;
  const icons = {
    success: <Check className="w-4 h-4" data-id="element-1155" />,
    error: <AlertTriangle className="w-4 h-4" data-id="element-1156" />,
    info: <Info className="w-4 h-4" data-id="element-1157" />
  };
  const styles = {
    success: 'bg-gray-900 dark:bg-white text-white dark:text-gray-900',
    error: 'bg-rose-600 dark:bg-rose-500 text-white',
    info: 'bg-blue-600 dark:bg-blue-500 text-white'
  };
  return <div className="fixed top-6 right-6 z-50 animate-slide-in-right" data-id="element-1158">
      <div className={`${styles[type]} px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 min-w-[300px] max-w-md`} data-id="element-1159">
        {icons[type]}
        <span className="text-sm font-medium flex-1" data-id="element-1160">{message}</span>
        <button onClick={onClose} className="p-1 hover:bg-white/10 rounded transition-colors" data-id="element-1161">
          <X className="w-4 h-4" data-id="element-1162" />
        </button>
      </div>
    </div>;
}